(() => {
  const init = () => {
    document.querySelectorAll('[data-eo-collection]').forEach(root => {
      if (root.dataset.eoReady) return;
      const description = root.querySelector('[data-eo-description]');
      const buyingGuide = root.querySelector('[data-eo-buying-guide]');
      const firstDetails = description?.querySelector('details');
      if (firstDetails && buyingGuide) {
        const range = document.createRange();
        range.setStartBefore(firstDetails);
        range.setEnd(description, description.childNodes.length);
        const guideContent = buyingGuide.querySelector('[data-eo-guide-content]');
        guideContent.append(range.extractContents());
        guideContent.querySelectorAll('[id]').forEach(node => {
          if (document.getElementById(node.id) !== node) node.removeAttribute('id');
        });
        buyingGuide.hidden = false;
        const introCopy = description.cloneNode(true);
        introCopy.querySelectorAll('style,script').forEach(node => node.remove());
        if (!introCopy.textContent.trim() && !introCopy.querySelector('img,video,iframe')) {
          root.querySelector('[data-eo-intro-guide]').hidden = true;
        }
      }
      root.dataset.eoReady = 'true';
      const filterToggle = root.querySelector('[data-eo-toggle-filters]');
      filterToggle.addEventListener('click', () => { const expanded = filterToggle.getAttribute('aria-expanded') !== 'true'; filterToggle.setAttribute('aria-expanded', String(expanded)); root.querySelector('[data-eo-filters]').classList.toggle('eo-filters--expanded', expanded); });
      root.querySelectorAll('[data-eo-tag-filter]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); const target = new URL(link.href); const params = new URLSearchParams(location.search); params.delete('page'); target.search = params.toString(); location.assign(target); }));
      const strings = JSON.parse(root.querySelector('[data-eo-strings]').textContent);
      const products = new Map();
      root.querySelectorAll('[data-eo-product]').forEach(node => {
        const data = JSON.parse(node.textContent);
        products.set(String(data.id), data);
      });
      const selection = new Map();
      const bar = root.querySelector('.eo-compare-bar');
      const announcement = root.querySelector('[data-eo-announcement]');
      const dialog = root.querySelector('dialog');
      const openButton = root.querySelector('[data-eo-open-compare]');
      const closeButton = root.querySelector('[data-eo-close]');
      const update = () => {
        bar.hidden = !selection.size;
        root.querySelector('[data-eo-selection]').textContent = strings.selected.replace('[count]', selection.size);
        openButton.disabled = selection.size < 2;
      };
      root.querySelectorAll('.eo-compare-select').forEach(label => { label.hidden = label.querySelector('input').disabled; });
      root.querySelectorAll('[data-eo-compare]').forEach(input => {
        input.checked = false;
        input.addEventListener('change', () => {
          const id = input.dataset.eoCompare;
          if (input.checked && selection.size && [...selection.values()][0].family !== products.get(id).family) { input.checked = false; announcement.textContent = strings.family_mismatch; return; }
          if (input.checked && selection.size === 3) {
            input.checked = false;
            announcement.textContent = strings.limit;
            return;
          }
          if (input.checked) selection.set(id, products.get(id));
          else selection.delete(id);
          announcement.textContent = '';
          update();
        });
      });
      root.querySelector('[data-eo-clear]').addEventListener('click', () => {
        selection.clear();
        root.querySelectorAll('[data-eo-compare]').forEach(input => { input.checked = false; });
        update();
      });
      const cell = (tag, text) => { const node = document.createElement(tag); node.textContent = text; return node; };
      openButton.addEventListener('click', () => {
        const selected = [...selection.values()];
        const table = document.createElement('table');
        const head = document.createElement('thead');
        const header = document.createElement('tr');
        header.append(cell('th', ''));
        selected.forEach(product => {
          const th = document.createElement('th');
          th.scope = 'col';
          const image = document.createElement('img');
          image.src = product.image; image.alt = product.title;
          const link = document.createElement('a');
          link.href = product.url; link.textContent = product.title;
          th.append(image, link); header.append(th);
        });
        head.append(header); table.append(head);
        const body = document.createElement('tbody');
        const attributeKeys = ['burr_type','burr_size_mm','dosing_style','adjustment','speed_control','boiler_system','pump_type','group_count','portafilter_mm','water_source','batch_capacity_g','heating_source','roast_control','voltage','condition'];
        const labels = strings.attributes.split('|');
        const familyKeys = { Grinder: ['burr_type','burr_size_mm','dosing_style','adjustment','speed_control','voltage','condition'], 'Espresso machine': ['boiler_system','pump_type','group_count','portafilter_mm','water_source','voltage','condition'], Roaster: ['batch_capacity_g','heating_source','roast_control','voltage','condition'] };
        const rows = [
          [strings.price, p => p.price],
          [strings.brand, p => p.vendor],
          ...(familyKeys[selected[0].family] || []).map(key => [labels[attributeKeys.indexOf(key)], p => p.attributes[key] == null ? strings.missing : String(p.attributes[key])]),
          [strings.availability, p => p.available ? strings.available : strings.unavailable]
        ];
        rows.forEach(([label, value]) => {
          const row = document.createElement('tr');
          const heading = cell('th', label); heading.scope = 'row'; row.append(heading);
          selected.forEach(product => row.append(cell('td', value(product))));
          body.append(row);
        });
        const links = document.createElement('tr'); links.append(cell('th', ''));
        selected.forEach(product => {
          const td = document.createElement('td'); const link = document.createElement('a');
          link.href = product.url; link.textContent = strings.details; td.append(link); links.append(td);
        });
        body.append(links); table.append(body);
        root.querySelector('[data-eo-comparison-table]').replaceChildren(table);
        dialog.showModal(); closeButton.focus();
      });
      closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
      dialog.addEventListener('close', () => openButton.focus());
      root.querySelector('[data-eo-sort]').addEventListener('change', () => root.querySelector('[data-eo-filters]').requestSubmit());
      root.querySelectorAll('.eo-filter').forEach(details => {
        details.addEventListener('toggle', () => {
          if (details.open) root.querySelectorAll('.eo-filter').forEach(other => { if (other !== details) other.open = false; });
        });
      });
      root.addEventListener('keydown', event => {
        if (event.key === 'Escape') root.querySelectorAll('.eo-filter[open]').forEach(details => { details.open = false; details.querySelector('summary').focus(); });
      });
      document.addEventListener('click', event => {
        if (!event.target.closest('.eo-filter')) root.querySelectorAll('.eo-filter[open]').forEach(details => { details.open = false; });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
